/**
* Link Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Link Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'link-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.link-marquee__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          autoHeight: true,
          gap: '32px',
          drag: false,
          autoScroll: {
            speed: 0.75,
            pauseOnHover: false,
          },
          arrows: false,
          pagination: false,
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'link-marquee', COMPONENT );
} )( app );
